import React, { useState, useEffect, useRef } from "react";
import furywheel from "../Image/furywheel.png";
import home from "../Image/homeicon.png";
import rank from "../Image/rank.png";
import refer from "../Image/refer.png";
import news from "../Image/news.png";
import about from "../Image/about.png";
import uparrow from "../Image/uparrow.png";
import earn from "../Image/earn.png";
import klingstaking from "../Image/s1.png";
import aboutstaking from "../Image/s2.png";
import chaticon from "../Image/chat-icon.png";
import usicon from "../Image/us-icon.png";
import telegram from "../Image/telegram.png";
import gameicon from "../Image/game-icon.png";
import linkdin from "../Image/linkdin.png";
import twitter from "../Image/twitter.png";
import { useNavigate } from "react-router-dom";
import { IoGameController } from "react-icons/io5";

function Leftsidebar({
  isSidebarOpen,
  setIsSidebarOpen,
  chatOpen,
  setChatOpen,
}) {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState();
  const [gameMenuOpen, setGameMenuOpen] = useState(false);

  const sidebarRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsSidebarOpen(false);
      }
    };

    if (isSidebarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSidebarOpen, setIsSidebarOpen]);

  return (
    <div>
      <div
        ref={sidebarRef}
        className={`sidebar ${isSidebarOpen ? "show" : ""}`}
      >
        <div className="m-4 furry-box">
          <div className="fury-btn d-flex justify-content-between align-items-center">
            <h2>FURY WHEEL</h2>
            <img src={furywheel} />
          </div>
        </div>

        <hr style={{ color: "#465164" }} />

        <ul className="menu">
          <li
            className="menu-item"
            onClick={() => {navigate("/")}}
          >
            <img src={home} alt="logo" /> Home
          </li>

          <li className="menu-group">
            <div
              className="menu-title"
              onClick={() => setGameMenuOpen(!gameMenuOpen)}
            >
              <div className="icon-text">
                <IoGameController style={{ color: "#2E5295" }} />
                <li>Games</li>
              </div>

              <div className={`arrow ${gameMenuOpen ? "rotate" : ""}`}>
                <img src={uparrow} alt="logo" />
              </div>
            </div>

            {gameMenuOpen && (
              <ul className="submenu">
                <li className="sub-item" onClick={() => navigate("/dicegame")}>
                  Dice Game
                </li>
                <li className="sub-item" onClick={() => navigate("/spinwheel")}>
                  Spin Wheel Game
                </li>
                <li className="sub-item" onClick={() => navigate("/minegame")}>
                  Mines Game
                </li>
                <li className="sub-item" onClick={() => navigate("/coinflip")}>
                  Coin Flip Game
                </li>
              </ul>
            )}
          </li>

          <li className="menu-item">
            <img src={rank} alt="logo" />
            Rank System
          </li>

          <li className="menu-group">
            <div className="menu-title" onClick={() => setOpen(!open)}>
              <div className="icon-text">
                <img src={earn} alt="logo" />
                <li>Kling Earn</li>
              </div>
              <div className={`arrow ${open ? "rotate" : ""}`}>
                <img src={uparrow} alt="logo" />
              </div>
            </div>

            {open && (
              <ul className="submenu">
                <li className="sub-item">
                  <img src={klingstaking} alt="logo" />
                  Kling Staking
                </li>
                <li className="sub-item">
                  <img src={aboutstaking} alt="" />
                  About Staking
                </li>
              </ul>
            )}
          </li>

          <li className="menu-item">
            <img src={refer} alt="" /> Referral
          </li>
          <li className="menu-item">
            <img src={news} alt="" /> News
          </li>
          <li className="menu-item">
            <img src={about} alt="" />
            About Kling
          </li>
          <div className="m-4">
            <li className="muted">Betfury Team</li>
            <li className="muted" onClick={() => navigate("/Privacy-Policy")}>
              Privacy Policy
            </li>
          </div>

          <div className="bottom">
            <div className="lang d-flex align-items-center justify-content-between">
              <div className="lang-left d-flex align-items-center gap-2">
                <img src={usicon} alt="" />
                <span>English</span>
              </div>
              <img src={uparrow} alt="" className="arrow-icon" />
            </div>

            <div className="support d-flex gap-2 align-items-center">
              <img src={chaticon} alt="" />
              Live support
            </div>

            <div className="d-flex m-4 gap-3 icons">
              <div>
                <a href="https://www.google.com/" target="_blank">
                  <img src={telegram} alt="telegram" />
                </a>
              </div>

              <div>
                <a href="https://www.google.com/" target="_blank">
                  <img src={gameicon} alt="game" />
                </a>
              </div>

              <div>
                <a href="https://www.google.com/" target="_blank">
                  <img src={linkdin} alt="linkedin" />
                </a>
              </div>

              <div>
                <a href="https://www.google.com/" target="_blank">
                  <img src={twitter} alt="twitter" />
                </a>
              </div>
            </div>
          </div>
        </ul>
      </div>
    </div>
  );
}

export default Leftsidebar;
